@file:OptIn(InternalResourceApi::class)

package cotizador.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/cotizador.composeapp.generated.resources/"

internal val Res.font.Montserrat_Medium: FontResource by lazy {
      FontResource("font:Montserrat_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/Montserrat-Medium.ttf", -1, -1),
      ))
    }

internal val Res.font.Poppins_Medium: FontResource by lazy {
      FontResource("font:Poppins_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/Poppins-Medium.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Montserrat_Medium", Res.font.Montserrat_Medium)
  map.put("Poppins_Medium", Res.font.Poppins_Medium)
}
